import { buildCyberTracerExportFilename, triggerDownload } from './downloadUtils.js';

/** Dedupe intelligence rows for debug JSON (same key as stream merge: URL + bucket, etc.). */
export function dedupeDebugBundleResults(results) {
  const list = Array.isArray(results) ? results.filter(Boolean) : [];
  const out = [];
  const seen = new Set();
  for (const r of list) {
    if (!r || typeof r !== 'object') continue;
    if (r.type === 'log') {
      out.push(r);
      continue;
    }
    const u = String(r.url || '')
      .trim()
      .toLowerCase();
    let key;
    if (u) key = `u:${r.ui_bucket || ''}:${u}`;
    else if (r.ui_bucket === 'relationship_node' && r.target_entity) {
      key = `rel:${String(r.target_entity).toLowerCase()}:nourl`;
    } else {
      const t = String(r.title || '').slice(0, 160);
      const s = String(r.snippet || '').slice(0, 120);
      key = `t:${r.ui_bucket || ''}:${t}:${s}`;
    }
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(r);
  }
  return out;
}

/**
 * Debug bundle export: editable JSON snapshot of current review state.
 * Intended for manual cleanup/re-import before final PDF generation.
 * Filename mirrors PDF: ``CyberTracer-{module}-{target}.json``.
 */
export function buildDebugBundlePayload({
  target = '',
  results = [],
  logs = [],
  extractedLeads,
  moduleName = 'intelligence',
} = {}) {
  return {
    schema: 'wiw-debug-bundle/v1',
    exported_at: new Date().toISOString(),
    moduleName,
    target,
    results: dedupeDebugBundleResults(Array.isArray(results) ? results : []),
    logs: Array.isArray(logs) ? logs : [],
    extractedLeads: {
      emails: Array.isArray(extractedLeads?.emails) ? extractedLeads.emails : [],
      associated_urls: Array.isArray(extractedLeads?.associated_urls) ? extractedLeads.associated_urls : [],
      associated_urls_partial: Array.isArray(extractedLeads?.associated_urls_partial)
        ? extractedLeads.associated_urls_partial
        : [],
      pivots: Array.isArray(extractedLeads?.pivots) ? extractedLeads.pivots : [],
    },
  };
}

/**
 * Debug bundle export: editable JSON snapshot of current review state.
 * Intended for manual cleanup/re-import before final PDF generation.
 * Filename mirrors PDF: ``CyberTracer-{module}-{target}.json``.
 */
export function exportDebugBundle({ target = '', results = [], logs = [], extractedLeads, moduleName = 'intelligence' }) {
  const payload = buildDebugBundlePayload({
    target,
    results,
    logs,
    extractedLeads,
    moduleName,
  });
  const filename = buildCyberTracerExportFilename({
    moduleName,
    target,
    extension: 'json',
  });
  triggerDownload(filename, `${JSON.stringify(payload, null, 2)}\n`, 'application/json;charset=utf-8');
}
